import React from "react";
import "./Conditions.module.css";

function Conditions(props) {

  return (
    <div className="Conditions">
        <h2>Мы создаем комфортные условия для жизни и работы</h2>
        <div className="ConditionsItems">
            <div className="ConditionsItem">
                <div className="ConditionsText">
                    <p className="ConditionsTextHeader">
                        Забота о команде
                    </p>
                    <p className="ConditionsTextDescription">
                        Забота о команде — часть нашей культуры. Программа ДМС, специальные предложения и эксклюзивные бонусы от партнеров — чтобы вы чувствовали поддержку не только на работе.
                    </p>
                </div>
                <div className="ConditionsIMG Vector">
                </div>
            </div>
            <div className="ConditionsItem">
                <div className="ConditionsText">
                    <p className="ConditionsTextHeader">
                        Финансовая надежность
                    </p>
                    <p className="ConditionsTextDescription">
                        Зарплата всегда приходит точно в срок — никаких задержек и переживаний. Ты уверенно строишь свои планы, потому что знаешь: мы держим слово. Надежность — не бонус, а стандарт. Также в компании внедрена система премирования по итогам квартала и года.
                    </p>
                </div>                
                <div className="ConditionsIMG Employee">
                </div>
            </div>
            <div className="ConditionsItem">
                <div className="ConditionsText">
                    <p className="ConditionsTextHeader">
                        Помогаем развиваться и достигать большего
                    </p>
                    <p className="ConditionsTextDescription">
                        Мы поддержим твой профессиональный и карьерный рост с первого дня: опытные наставники, амбициозные проекты, современные программы обучения и возможности проявить себя.
                    </p>
                </div>
                <div className="ConditionsIMG Ellipse">
                </div>
            </div>
            <div className="ConditionsItem">
                <div className="ConditionsText">
                    <p className="ConditionsTextHeader">
                        Комфортные офисы
                    </p>
                    <p className="ConditionsTextDescription">
                        Наши офисы — это современные digital-пространства, где комфорт сочетается с функциональностью, чтобы тебе было удобно творить, решать задачи и просто чувствовать себя на своём месте.
                    </p>
                </div>
                <div className="ConditionsIMG Office">
                </div>
            </div>
            <div className="ConditionsItem">
                <div className="ConditionsText">
                    <p className="ConditionsTextHeader">
                        ЭР — больше, чем работа
                    </p>
                    <p className="ConditionsTextDescription">
                        Мы хорошо работаем и хорошо отдыхаем вместе! Тебя ждут масштабные корпоративы, яркие праздники, приглашённые звёзды и незабываемые моменты!
                    </p>
                </div>
                <div className="ConditionsIMG Event">
                </div>
            </div>
            <div className="ConditionsItem">
                <div className="ConditionsText">
                    <p className="ConditionsTextHeader">
                        Мы выбираем технологичность
                    </p>
                    <p className="ConditionsTextDescription">
                        Современная инфраструктура, технологичные продукты и команда профи - у нас есть всё, чтобы строить будущее, опережать тренды и создавать современные решения.
                    </p>
                </div>
                <div className="ConditionsIMG Cable">
                </div>
            </div>
        </div>
    </div>
  );
}

export default Conditions;



// WEBPACK FOOTER //
// ./src/components/Conditions/index.js